import { createRouter, createWebHistory, RouteRecordRaw,createWebHashHistory } from 'vue-router';
import Home from '../views/Home.vue';
import ProductDetail from '../views/ProductDetail.vue';
import Login from '../views/Login.vue';
import Customer from '../views/Customer.vue';
import Empty from "../views/Empty.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/ProductDetail',
    name: 'ProductDetail',
    component: ProductDetail
  },
  //空白中转页面
  {
    path: '/Empty',
    name: 'Empty',
    component: Empty
  },

  //登录  
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },
  {
    path: '/Customer',
    name: 'Customer',
    component: Customer
  },
  // {
  //   path: '/:catchAll(.*)',
  //   name: '404',
  //   redirect: {
  //     name: 'Home'
  //   }
  // }
  {
    path: "/404",
    component: () => import("@/views/404.vue"),
    name: "404",
    // 个性化数据根据实际情况处理
    meta: {
      auth: false,
      title: "404",
    },
  },
  {
    path: "/:pathMatch(.*)",
    name: "notFound",
    redirect: "/404",
  },
];
const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),  //history模式打包后报错
  history: createWebHashHistory(), // 使用 Hash 模式
  routes,
});

export default router;
